import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { editEventRequest, editEventRequestError, editEventRequestSuccess } from "../../slices/event-management/EditEventSlice";

export const EditEventAPI =
    (data) => async (dispatch) => {
        try {
            dispatch(editEventRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.updateEvent,
                data: data,
            })
            return dispatch(editEventRequestSuccess(response.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(editEventRequestError(_error));
        }
    };
